import { useEffect, useState } from "react"
import { TUnauthorizedState } from "../IRouteWithState"
import Login from "../../pages/login/login"
import Otp from "../../pages/otp/otp"
import { useSelector } from "react-redux"
import { RootState } from "../../redux/store"
import UnauthorizedContainer from "../../pages/navigationButtonComponents/walletContainer/unauthorizedContainer"
import RouteWithState from "../routeWithState";
import LandingPage from "../../pages/landing/landingPage"
import PrivacyStatements from "../../pages/privacyStatements/privacyStatements"
import OngoingDetailPurchase from "../../pages/purchase/ongoingDetailPurchase"
import { useMutation, useQueryClient } from "react-query"
import { SALE_ID } from "../../config/cacheKey"
import { GetWaitForCustomerApproveSales } from "../../services/sale.service"
import { IGetWaitForCustomerApproveSalesResponse } from "../../models/sale.model"

export default function UnAuthoized() {
    const [state, setState] = useState<TUnauthorizedState>();

    const unAuthorized_Redux = useSelector(
        (state: RootState) => state.unAutorizedState.state
    ) as TUnauthorizedState;
    const queryClient = useQueryClient();
    useEffect(() => {
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        metaThemeColor!.setAttribute('content', '#F5F6FA');


    }, [])

    useEffect(() => {

        if (unAuthorized_Redux.includes('login')) {
            setState('login');

        } else if (unAuthorized_Redux.includes('otp')) {
            setState('otp');
        }
        else if (unAuthorized_Redux.includes('routeWithState')) {
            setState('routeWithState');
        }
        // else if (unAuthorized_Redux.includes('landingPage')) {
        //     setState('landingPage');
        // } 
        else if (unAuthorized_Redux.includes('privacyStatements')) {
            setState('privacyStatements');
        } else {
            setState('login');
        }
    }, [unAuthorized_Redux])

    useEffect(() => {
        // this section might need to be updated(todo)
        const path = window.location.hash;
        const saleKey = path.split('/')[2];

        if (path.toLowerCase().includes("/ongoingdetailpurchase/") && saleKey != null && saleKey != "") {
            // setState('unauthorizedOngoingDetailPurchase');
            const newPath = `${window.location.protocol}//${window.location.host}`;

            queryClient.setQueryData(SALE_ID, saleKey);

            window.history.replaceState(null, '', newPath);
        }
    }, [])
    const unAuthoizedStatus = {
        login: <Login />,
        otp: <Otp />,
        UnauthorizedContainer: <UnauthorizedContainer />,
        routeWithState: <RouteWithState />,
        landingPage: <LandingPage />,
        unauthorizedOngoingDetailPurchase: <OngoingDetailPurchase ongoingPurchases={0} setState={setState} />,
        privacyStatements: <PrivacyStatements />,
    }
    return (
        <>
            {unAuthoizedStatus[state!]}
        </>
    )
}
